module.exports = __webpack_public_path__ + "static/media/12.fa844234.jpg";